const onIdle = (callback: () => void): void => {
    if(typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(() => callback(), { timeout: 3000 });
        return;
    }

    setTimeout(callback, 500);
};

export default onIdle;
